import useGlobalStyles from '@/styles/global.styles';

import useStyles from './CategoryPill.styles';

export enum CategoryPillVariant {
  LG,
  SM,
}

interface CategoryPillProps {
  label: string;
  active?: boolean;
  variant?: CategoryPillVariant;
  clickHandler?: () => void;
}

export default function CategoryPill({
  label,
  active,
  variant,
  clickHandler,
}: CategoryPillProps): React.JSX.Element {
  const { classes, cx } = useStyles();
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });
  return (
    // biome-ignore lint/a11y/useButtonType: Automated migration to Biome
    <button
      className={cx(
        globalClasses.body,
        classes.categoryPill,
        active && classes.categoryPillActive,
        variant === CategoryPillVariant.SM && classes.categoryPillNarrow
      )}
      onClick={clickHandler}
    >
      {label}
    </button>
  );
}
